import { createSlice } from '@reduxjs/toolkit';

import endPoints from '../api/endpoint';
import {
  deleteApiCall,
  getApiCall,
  apiSuccessCode,
  postApiCall,
  putApiCall,
} from '../api/methods';

import store from './store';

import { notify } from '../Utils/toastify';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../Utils/firebaseConfig';
import { ANALYTICS_EVENTS } from '../helpers/analyticsEvents';

import { CommonState } from '../types';
import { debounce } from '../Utils/helperFns';

const initialState: CommonState = {
  countryList: [],
  departmentList: [],
  categories: [],
  loading: false,
  page: 1,
  searchedLocations: [],
  filterapplied: false,
  searchParamsForProduction: '',
  searchParamsForEpisode: '',
  menu: true,
  deptList: [],
  positionList: [],
  selectedTalentUser: {},
  presignedSignedUrl: [],
  selectedProductionId: {},
  emailunique: [],
  departmentSignUplist: [],
  roleList: [],
  UserListSignUp: [],
  selectedStudio: {},
  selectedEpisode: {},
  selectedLocation: {},
  selectedProduction: {},
  selectedSet: {},
  selectedTabValue: 0,
  studioCards: {},
  deptLists: [],
  permissionsData: [],
  selectedAddress: {},
  unreadCount: 0,
  profileData: {},
  selectedEntity: {},
  breadcrumbs: [],
  spendingBreadcrumbs: [],
  departmentAddContact: [],
  orderListDept: {},
  accordian: false,
  accessDashboards: {},
  assosiatedList: {},
  userPermissionData: {},
  accountControl: {},
  selectedTab: 0,
  selectedProd: {},
  previewShiftDetails: {},
  addMoreItems: {},
  startOrderData: {},
  selectedEntityType: '',
  riskBreadcrumbs: [],
  loggedInMemberType: '',
  isRiskAnalystUser: false,
  verifyOtpLoading: false,
  manageEntitiesPicker: {
    productionData: [],
    episodesPagedData: [],
    setsPagedData: [],
    locationsPagedData: [],
    productionsLoading: false,
    episodesLoading: false,
    setsLoading: false,
    locationsLoading: false,
  },
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setManageEntitiesPickerState: (state, action) => {
      const { payload }: any = action;
      state.manageEntitiesPicker = {
        ...(state.manageEntitiesPicker || {}),
        ...(payload || {}),
      };
    },
    resetManageEntitiesPickerState: state => {
      state.manageEntitiesPicker = {
        productionData: [],
        episodesPagedData: [],
        setsPagedData: [],
        locationsPagedData: [],
        productionsLoading: false,
        episodesLoading: false,
        setsLoading: false,
        locationsLoading: false,
      };
    },
    setData: (state, action) => {
      const {
        payload: { type, value },
      }: any = action;
      if (type === 'country') {
        state.countryList = value;
      } else if (type === 'department') {
        state.departmentList = value;
      } else if (type === 'categories') {
        state.categories = value;
      }
    },
    updatePage: (state, action) => {
      const { payload }: any = action;
      state.page = payload;
    },
    setCommonDataLoader: (state, action) => {
      const { payload }: any = action;
      state.loading = payload;
    },
    updateSearchedLocations: (state, action) => {
      const { payload }: any = action;
      state.searchedLocations = payload;
    },
    setFilterApplied: (state, action) => {
      state.filterapplied = action.payload;
    },
    setSearchParamsForProduction: (state, action) => {
      state.searchParamsForProduction = action.payload;
    },
    setSearchParamsForEpisode: (state, action) => {
      state.searchParamsForEpisode = action.payload;
    },
    setCommonMenu: (state, action) => {
      const { payload }: any = action;
      state.menu = payload;
    },
    setDeptList: (state, action) => {
      const { payload }: any = action;
      state.deptList = payload;
    },
    setAssosiatedList: (state, action) => {
      const { payload }: any = action;
      state.assosiatedList = payload;
    },
    setOrderListDept: (state, action) => {
      const { payload }: any = action;
      state.orderListDept = payload;
    },
    setDepartmentListSignUp: (state, action) => {
      const { payload }: any = action;
      state.departmentSignUplist = payload;
    },
    setDepartmentListAddContact: (state, action) => {
      const { payload }: any = action;
      state.departmentAddContact = payload;
    },
    setRoleList: (state, action) => {
      const { payload }: any = action;
      state.roleList = payload;
    },
    setStaticRoles: (state, action) => {
      const { payload }: any = action;
      state.positionList = payload;
    },
    setUniqueEmail: (state, action) => {
      const { payload }: any = action;
      state.emailunique = payload;
    },
    setPresignedUrl: (state, action) => {
      const { payload }: any = action;
      state.presignedSignedUrl = payload;
    },
    setSelectedTalentUser: (state, action) => {
      const { payload }: any = action;
      state.selectedTalentUser = payload;
    },
    setSelectedProductionId: (state, action) => {
      const { payload }: any = action;
      state.selectedProductionId = payload;
    },
    setUserListSignUp: (state, action) => {
      const { payload }: any = action;
      state.UserListSignUp = payload;
    },
    setSelectedEpisode: (state, action) => {
      const { payload }: any = action;
      state.selectedEpisode = payload;
    },
    setSelectedLocation: (state, action) => {
      const { payload }: any = action;
      state.selectedLocation = payload;
    },
    setSelectedProduction: (state, action) => {
      const { payload }: any = action;
      state.selectedProduction = payload;
    },
    setSelectedSet: (state, action) => {
      const { payload }: any = action;
      state.selectedSet = payload;
    },
    setSelectedStudio: (state, action) => {
      const { payload }: any = action;
      state.selectedStudio = payload;
    },
    setSelectedTabValue: (state, action) => {
      const { payload }: any = action;
      state.selectedTabValue = payload;
    },
    setSelectedTab: (state, action) => {
      const { payload }: any = action;
      state.selectedTab = payload;
    },
    setDeptLists: (state, action) => {
      const { payload }: any = action;
      state.deptLists = payload;
    },
    setStudioCards: (state, action) => {
      const { payload }: any = action;
      state.studioCards = payload;
    },
    setpermissionsData: (state, action) => {
      const { payload }: any = action;
      state.permissionsData = payload;
    },
    updateSelectedAddresses: (state: any, action: any) => {
      const { payload }: any = action;
      state.selectedAddress = payload;
    },
    setUnreadCount: (state, action) => {
      const { payload }: any = action;
      state.unreadCount = payload;
    },
    setProfileData: (state, action) => {
      const { payload }: any = action;
      state.profileData = payload;
    },
    setSelectedEntity: (state, action) => {
      const { payload }: any = action;
      state.selectedEntity = payload;
    },
    updateBreadcrumbs: (state, action) => {
      const { payload }: any = action;
      state.breadcrumbs = payload;
    },
    updateSpendingBreadcrumbs: (state, action) => {
      const { payload }: any = action;
      state.spendingBreadcrumbs = payload;
    },
    setAccordion: (state, action) => {
      const { payload }: any = action;
      state.accordian = payload;
    },
    SetDashboardAccess: (state, action) => {
      const { payload }: any = action;
      state.accessDashboards = payload;
    },
    setUserPermissionData: (state, action) => {
      const { payload }: any = action;
      state.userPermissionData = payload;
    },
    setAccountControlData: (state, action) => {
      const { payload }: any = action;
      state.accountControl = payload;
    },
    setSelectedProd: (state, action) => {
      const { payload }: any = action;
      state.selectedProd = payload;
    },
    setPreviewShiftDetails: (state, action) => {
      const { payload }: any = action;
      state.previewShiftDetails = payload;
    },
    setAddMoreItems: (state, action) => {
      const { payload } = action;
      state.addMoreItems = payload;
    },
    setStartOrderData: (state, action) => {
      const { payload } = action;
      state.startOrderData = payload;
    },
    setSelectedEntityType: (state, action) => {
      const { payload } = action;
      state.selectedEntityType = payload;
    },
    updateRiskBreadcrumbs: (state, action) => {
      const { payload }: any = action;
      state.riskBreadcrumbs = payload;
    },
    setLoggedInMemberType: (state, action) => {
      const { payload }: any = action;
      state.loggedInMemberType = payload;
    },
    setIsRiskAnalystUser: (state, action) => {
      const { payload }: any = action;
      state.isRiskAnalystUser = payload;
    },
    setVerifyOtpLoading: (state, action) => {
      const { payload }: any = action;
      state.verifyOtpLoading = payload;
    },
  },
});

export const {
  setData,
  setCommonDataLoader,
  updatePage,
  updateSearchedLocations,
  setFilterApplied,
  setSearchParamsForProduction,
  setSearchParamsForEpisode,
  setCommonMenu,
  setDeptList,
  setAssosiatedList,
  setStaticRoles,
  setSelectedTalentUser,
  setPresignedUrl,
  setSelectedProductionId,
  setDepartmentListAddContact,
  setUniqueEmail,
  setDepartmentListSignUp,
  setUserListSignUp,
  setRoleList,
  setStudioCards,
  setSelectedStudio,
  setSelectedEpisode,
  setSelectedSet,
  setSelectedProduction,
  setSelectedLocation,
  setSelectedTabValue,
  setDeptLists,
  setpermissionsData,
  updateSelectedAddresses,
  setUnreadCount,
  setProfileData,
  setSelectedEntity,
  setOrderListDept,
  updateBreadcrumbs,
  setAccordion,
  SetDashboardAccess,
  setUserPermissionData,
  setAccountControlData,
  setSelectedTab,
  updateSpendingBreadcrumbs,
  setSelectedProd,
  setPreviewShiftDetails,
  setAddMoreItems,
  setStartOrderData,
  setSelectedEntityType,
  updateRiskBreadcrumbs,
  setLoggedInMemberType,
  setIsRiskAnalystUser,
  setVerifyOtpLoading,
  setManageEntitiesPickerState,
  resetManageEntitiesPickerState,
} = commonSlice.actions;

export default commonSlice.reducer;

const convertToQueryParam = (payload: Record<string, any>) => {
  const keys = Object.keys(payload || {});
  if (keys.length === 0) return '';
  const queryString = keys.reduce((query, key) => {
    if (payload[key]) {
      return `${query}${key}=${encodeURIComponent(payload[key])}&`;
    }
    return query;
  }, '?');
  return queryString.substring(0, queryString.length - 1);
};

export interface RestrictedListingResult<T> {
  ok: true;
  items: T[];
  total?: number;
}

export interface RestrictedListingError {
  ok: false;
  message?: string;
}

export const fetchProductions = async (
  params: {
    studioId: string;
    searchKey?: string;
  },
  cb?: any,
) => {
  const queryParams = convertToQueryParam(params);
  getApiCall(
    `${endPoints.studio.studioProductionsRestricted}${queryParams}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        cb?.(data.data);
      }
    },
    (e: any) => {
      console.log(e);
    },
  );
};

export const fetchEpisodesPaged = async (
  params: {
    productionId?: string;
    studioId?: string;
    searchKey?: string;
  },
  cb?: any,
) => {
  const queryParams = convertToQueryParam(params);
  getApiCall(
    `${endPoints.production.episodesRestricted}${queryParams}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        cb?.(data.data);
      }
    },
    (e: any) => {
      console.log(e);
    },
  );
};

export const fetchSetsPaged = async (
  params: {
    productionId?: string;
    studioId?: string;
    episodeId?: string | null;
    searchKey?: string;
  },
  cb?: any,
) => {
  const queryParams = convertToQueryParam(params);

  getApiCall(
    `${endPoints.production.setsRestricted}${queryParams}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        cb?.(data.data);
      }
    },
    (e: any) => {
      console.log(e);
    },
  );
};

export const fetchLocationsPaged = async (
  params: {
    setId?: string;
    studioId?: string;
    productionId?: string;
    episodeId?: string;
    searchKey?: string;
  },
  cb?: any,
) => {
  const queryParams = convertToQueryParam(params);
  getApiCall(
    `${endPoints.set.setLocationsRestricted}${queryParams}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        cb?.(data.data);
      }
    },
    (e: any) => {
      console.log(e);
    },
  );
};

export const getAndSetData = (type: string) => {
  const apiEndpoint =
    type === 'country'
      ? endPoints.common.countryList
      : type === 'department'
      ? endPoints.common.deparmentList
      : endPoints.common.categories;

  store.dispatch(setCommonDataLoader(true));
  getApiCall(
    `${apiEndpoint}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        store.dispatch(setData({ type: type, value: data.data }));
      }
      store.dispatch(setCommonDataLoader(false));
    },
    (_e: any) => {
      store.dispatch(setCommonDataLoader(false));
      notify(`Error while fetching ${type} list`, 'error');
    },
    type === 'country'
      ? {
          Authorization: `Basic ${btoa(
            `${process.env.API_BASIC_AUTH_CREDENTIALS}`,
          )}`,
        }
      : {},
  );
};
export const updatePaginationPage = (page: number) => {
  const { dispatch } = store;
  dispatch(updatePage(page));
};

export async function fetchLocationByText(location: string) {
  const { dispatch } = store;
  console.log(location, 'loc');

  const apiKey = process.env.GOOGLE_API_KEY;
  const response = await fetch(
    `https://maps.googleapis.com/maps/api/geocode/json?address=${location}&key=${apiKey}`,
  );
  response.json().then(data => {
    if (data.results) {
      dispatch(updateSearchedLocations(data.results));
      console.log(data);
    }
  });
}

export const getAllDepartmentList = () => {
  const apiEndpoint = endPoints.departments;

  store.dispatch(setCommonDataLoader(true));
  getApiCall(
    `${apiEndpoint}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        store.dispatch(setDeptList(data.data));
      }
      store.dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      console.log(e);
      store.dispatch(setCommonDataLoader(false));
      notify(`Error while fetching deparment list`, 'error');
    },
  );
};

export const getOrderListDepartments = (
  entityId?: any,
  entityType?: any,
  departmentId?: any,
  module?: any,
  moduleId?: any,
) => {
  let apiEndpoint = `${endPoints.webOrder}?entityId=${entityId}`;

  if (entityType) {
    apiEndpoint += `&entityType=${entityType}`;
  }
  if (departmentId) {
    apiEndpoint += `&departmentId=${departmentId}`;
  }

  if (module && moduleId) {
    if (module === 'episodes') {
      apiEndpoint += `&episodeId=${moduleId}`;
    } else if (module === 'locations') {
      apiEndpoint += `&locationId=${moduleId}`;
    } else {
      apiEndpoint += `&setId=${moduleId}`;
    }
  }

  store.dispatch(setCommonDataLoader(true));
  getApiCall(
    `${apiEndpoint}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        store.dispatch(setOrderListDept(data.data));
      }
      store.dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      console.log(e);
      store.dispatch(setCommonDataLoader(false));
      notify(`Error while fetching department list`, 'error');
    },
  );
};

export const getStaticRoles = () => {
  const apiEndpoint = endPoints.staticRoles;

  store.dispatch(setCommonDataLoader(true));
  getApiCall(
    `${apiEndpoint}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        store.dispatch(setStaticRoles(data.data));
      }
      store.dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      console.log(e);
      store.dispatch(setCommonDataLoader(false));
      notify(`Error while fetching deparment list`, 'error');
    },
  );
};

export const debouncedEmailCheck = debounce((email: string, cb?: any) => {
  if (!email) return; // Prevent empty requests
  const apiEndpoint = `${endPoints.production.emailuniqueness}?email=${email}`;
  store.dispatch(setCommonDataLoader(true));

  getApiCall(
    apiEndpoint,
    (response: any) => {
      const { data } = response;
      console.log(data, 'data8989s');
      cb?.(true);
      if (data.statusCode === 200) {
        store.dispatch(setUniqueEmail(data.data));
        //  notify('Success', 'success');
        cb?.(false); // Call callback with false (no error)
      } else {
        notify(
          'This email is already in use. Please use a different email.',
          'error',
        );
        cb?.(true); // Call callback with false (no error)
      }
      store.dispatch(setCommonDataLoader(false));
    },
    (error: any) => {
      console.log(error);
      //  notify(error.data.message, 'error')
      cb?.(true);
      // console.error('Error checking email uniqueness:', error);
      store.dispatch(setCommonDataLoader(false));
      // notify('An error occurred while checking email uniqueness.', 'error');
    },
  );
}, 800);

export const getPresignedUrl = () => {
  const apiEndpoint = endPoints.getPresignedUrl;

  store.dispatch(setCommonDataLoader(true));
  getApiCall(
    `${apiEndpoint}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        store.dispatch(setPresignedUrl(data.data));
      }
      store.dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      console.log(e);
      store.dispatch(setCommonDataLoader(false));
      notify(`Error while fetching deparment list`, 'error');
    },
  );
};
export const uploadDocument = (values: any, cb?: any, errCb?: any) => {
  postApiCall(
    endPoints.uploadDocument,
    values,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;

      if (statusCode && statusCode === 200) {
        notify(message, 'success');
        if (cb) cb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
      if (errCb) errCb();
    },
  );
};

export const createDepartment = (values: any, cb?: any, errorCb?: any) => {
  postApiCall(
    endPoints.addDepartment,
    values,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;

      if (statusCode && statusCode === 200) {
        notify(message, 'success');
        if (cb) cb();
      } else {
        if (errorCb) errorCb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
      if (errorCb) errorCb();
    },
  );
};

export const addContactCrew = (
  values: any,
  cb?: any,
  cbe?: any,
  isStudio?: boolean,
) => {
  postApiCall(
    endPoints.addCrewContact,
    values,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;

      if (statusCode && statusCode === 200) {
        if (!isStudio) {
          notify(message, 'success');
        }
        try {
          logEvent(analytics, ANALYTICS_EVENTS.CONTACT_INVITED, {
            entity_type: values?.entityType,
          });
        } catch (_) {}
        if (cb) cb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
        if (cbe) cbe();
      }
    },
  );
};

export const Logout = (cb?: any) => {
  postApiCall(
    endPoints.logout,
    {},
    (s: any) => {
      const {
        data: { statusCode },
      } = s;

      if (statusCode && statusCode === 200) {
        // notify(message, 'success')
        if (cb) cb(true);
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export type DeactivateMyAccountResult =
  | { ok: true }
  | { ok: false; type?: string; message?: string };

export const deactivateMyAccount = (
  cb?: (result: DeactivateMyAccountResult) => void,
) => {
  putApiCall(
    endPoints.deactivateAccount,
    {},
    (s: any) => {
      const {
        data: { statusCode, message, type },
      } = s;

      if (statusCode && statusCode === 200) {
        if (message) notify('Account deactivated successfully', 'success');
        if (cb) cb({ ok: true });
      } else {
        if (cb) cb({ ok: false, type, message });
      }
    },
    (e: any) => {
      const type = e?.data?.type;
      if (cb)
        cb({
          ok: false,
          type,
          message:
            'You have active dependencies linked to your profile (e.g., ongoing orders, invoices, or production ownership).Please resolve these before deactivating your account.',
        });
    },
  );
};

export const addTalentUser = (values: any) => {
  console.log('dataToSend', values);
  store.dispatch(setSelectedTalentUser(values));
};

export const getProductionUserDetails = (id: string, cb?: any) => {
  const { dispatch } = store;
  const apiendpoint = endPoints.riskCenter.userDetailsByProduction(id);

  dispatch(setCommonDataLoader(true));

  // Make the API call
  getApiCall(
    `${apiendpoint}`,
    (s: any) => {
      const { data } = s;

      if (data?.data) {
        console.log('UserDDDD Booking Details =>>>>>', data);

        const payload = {
          ...data?.data,
          userDetail: [
            {
              ...data?.data?.userDetail,
              fullName: `${data?.data?.userDetail?.firstName} ${data?.data?.userDetail?.lastName}`,
            },
          ],
        };
        addTalentUser(payload);
        cb(payload);
        // dispatch(setCabBookingDetails(data?.data))
        // dispatch(setLoaderStatus(false))
        dispatch(setCommonDataLoader(false));
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
        // dispatch(setLoaderStatus(false))
        dispatch(setCommonDataLoader(false));
      }
    },
  );
};

export const addSelectedProductionId = (data: any) => {
  // setSelectedProductionId
  store.dispatch(setSelectedProductionId(data));
};

export const getDepartmentListForsignupFlow = () => {
  const apiEndpoint = endPoints.departmentlist;

  store.dispatch(setCommonDataLoader(true));
  getApiCall(
    `${apiEndpoint}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        store.dispatch(setDepartmentListSignUp(data.data));
      }
      store.dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      console.log(e);
      store.dispatch(setCommonDataLoader(false));
      notify(`Error while fetching deparment list`, 'error');
    },
  );
};

export const getDepartmentListForAddContact = () => {
  const apiEndpoint = endPoints.production.departmentList;

  store.dispatch(setCommonDataLoader(true));
  getApiCall(
    `${apiEndpoint}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        store.dispatch(setDepartmentListAddContact(data.data));
      }
      store.dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      console.log(e);
      store.dispatch(setCommonDataLoader(false));
      notify(`Error while fetching deparment list`, 'error');
    },
  );
};

export const getRoleList = (departmentId: any) => {
  const apiEndpoint = `${endPoints.roleList}?deptIds=${departmentId}`;

  store.dispatch(setCommonDataLoader(true));
  getApiCall(
    `${apiEndpoint}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        store.dispatch(setRoleList(data.data));
      }
      store.dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      console.log(e);
      store.dispatch(setCommonDataLoader(false));
      notify(`Error while fetching deparment list`, 'error');
    },
  );
};

export const getStudioCardsList = (studioId: any) => {
  const apiEndpoint = endPoints.studiodashcards + studioId;

  store.dispatch(setCommonDataLoader(true));
  getApiCall(
    `${apiEndpoint}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        store.dispatch(setStudioCards(data.data));
      }
      store.dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      console.log(e);
      store.dispatch(setCommonDataLoader(false));
      //notify(`Error while fetching deparment list`, 'error')
    },
  );
};

export const getUserDetailsSignUpFlow = (payload: any, cb?: () => void) => {
  postApiCall(
    `${endPoints.userdetailssignUp}`,
    payload,
    (s: any) => {
      const { data } = s;

      if (data.data) {
        store.dispatch(setUserListSignUp(data.data));
        // reset()
      }
      if (cb) cb();
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const ManageDepartment = (payload: any, cb?: () => void) => {
  postApiCall(
    `${endPoints.riskCenter.manageDeptList}`,
    payload,
    (s: any) => {
      const {
        data: { statusCode },
      } = s;

      if (statusCode && statusCode === 200) {
        notify('Departments updated successfully', 'success');
        if (cb) cb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const getProfileImage = (values?: any, cb?: any) => {
  // return (dispatch: any, getState: any) => {
  console.log('dataToSend', values);
  // dispatch(setCommonDataLoader(true))
  putApiCall(
    `${endPoints.profileImage}`,
    values,
    (s: any) => {
      const {
        data: { statusCode },
      } = s;
      cb && cb();

      console.log('RESSS', s);
      if (statusCode && statusCode === 200) {
        //  notify(message, 'success')
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
  // }
};

// export const getDeptLists = () => {
//   const apiEndpoint = endPoints.departmentsList

//   store.dispatch(setCommonDataLoader(true))
//   getApiCall(
//     `${apiEndpoint}`,
//     (s: any) => {
//       const { data: data } = s
//       if (data.data) {
//         store.dispatch(setDeptLists(data.data))
//       }
//       store.dispatch(setCommonDataLoader(false))
//     },
//     (e: any) => {
//       console.log(e)
//       store.dispatch(setCommonDataLoader(false))
//       notify(`Error while fetching deparment list`, 'error')
//     }
//   )
// }

export const getDeptLists = (
  page?: number | any,
  entityType?: string | any,
  entityId?: string | any,
  searchKey?: any,
  cb?: any,
  setHasMore?: any,
  isModel?: boolean,
) => {
  const { dispatch } = store;
  // dispatch(setLoading(true))
  const apiendpoint = endPoints.departmentsLists;

  // Construct query parameters dynamically
  let endpoint = `${apiendpoint}?page=${
    page || 1
  }&limit=20&entityType=${entityType}&entityId=${entityId}`;

  // Only append searchKey if it is provided and not empty
  if (searchKey) {
    endpoint += `&searchKey=${encodeURIComponent(searchKey)}`;
  }

  getApiCall(
    endpoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        if (isModel) {
          const currentData = data.data.depts;
          cb(currentData);

          // Determine if there is more data
          if (setHasMore) {
            const hasMore = currentData.length === 20; // If less than 10, no more data
            setHasMore(hasMore);
          }
          // cb((prev: any) => [...prev, ...data.data.data])
        } else {
          dispatch(setDeptLists(data.data));
        }

        // cb(data?.data?.depts)
      }
      // dispatch(setLoading(false))
    },

    (e: any) => {
      notify(e?.data?.message, 'error');
    },
  );
};

export const getPermissions = (
  entityType: string,
  entityId: string,
  userType: string,
): void => {
  const { dispatch } = store;
  dispatch(setCommonDataLoader(true));

  // Build the API endpoint
  const apiendpoint =
    `${endPoints.permissions}?entityType=${entityType}` +
    `&entityId=${entityId}&userType=${userType}`;

  // API call
  getApiCall(
    apiendpoint,
    (response: any) => {
      const { data } = response;

      if (data?.data) {
        dispatch(setpermissionsData(data?.data));
      }
      dispatch(setCommonDataLoader(false));
    },
    (error: any) => {
      console.error('Error fetching episode list:', error);
      dispatch(setCommonDataLoader(false));
    },
  );
};

export const deleteDocument = (
  enityType: string | any,
  entityId: any,
  documentId?: any,
  deptId?: any,
  cb?: any,
  options?: { useGlobalLoader?: boolean },
) => {
  const { dispatch } = store;
  const useGlobalLoader = options?.useGlobalLoader !== false;
  if (useGlobalLoader) {
    dispatch(setCommonDataLoader(true));
  }
  deleteApiCall(
    `${endPoints.deleteDoc}/${enityType}/${entityId}/${documentId}/${deptId}`,
    {},
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;
      if (statusCode && statusCode === 200) {
        notify(message, 'success');
        if (cb) cb();
        if (useGlobalLoader) {
          dispatch(setCommonDataLoader(false));
        }
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
      if (useGlobalLoader) {
        dispatch(setCommonDataLoader(false));
      }
    },
  );
};

export const getUnreadCount = () => {
  const { dispatch } = store;
  getApiCall(
    `${endPoints.notification.unreadCount}/false`,
    (s: any) => {
      const {
        data: { statusCode, data },
      } = s;
      if (statusCode && statusCode === apiSuccessCode.success) {
        dispatch(setUnreadCount(data));
      }
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function -- errors are intentionally ignored here
    (_e: any) => {},
  );
};

export const setSelectedAddress = (address: any = {}) => {
  const { dispatch } = store;

  // console.log('ADDRESS =>', address)

  dispatch(updateSelectedAddresses(address));
};

export const getUserProfileData = (cb?: any, errorcb?: any) => {
  const { dispatch } = store;

  const apiEndPoint = endPoints.production.userProfile;

  getApiCall(
    apiEndPoint,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        dispatch(setProfileData(data.data));

        if (cb) cb(data?.data); // Call the callback function if provided
      }
    },
    (e: any) => {
      errorcb?.();
      // Handle error if necessary (you can log it or display a toast, etc.)
      console.error('Error fetching production details:', e);
    },
  );
};

export const markAsDefault = (values: any, cb?: any) => {
  postApiCall(
    endPoints.markDefault,
    values,
    (s: any) => {
      const {
        data: { statusCode },
      } = s;

      if (statusCode && statusCode === 200) {
        if (cb) cb();
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

/**
 * Adds a new breadcrumb to the existing list.
 * @param {any} data The new breadcrumb to add. Should contain a `label` and a `path`
 */
// export const setBreadCrumbs = (data: any) => {
//   const { dispatch, getState } = store
//   const { breadcrumbs } = getState()?.common

//   // Create a new array with the existing breadcrumbs and the new one
//   let newBres = [...breadcrumbs, ...data]

//   // Use a Map to ensure unique paths (preserves the last occurrence)
//   const uniqueBreadcrumbs = Array.from(
//     new Map(newBres?.map((b) => [b.path, b])).values()
//   )
//   // navigate: index - (arr.length - 1), // Ensuring last added is 0, previous shift left

//   // console.log('breadcrumbs', update)
//   dispatch(updateBreadcrumbs(uniqueBreadcrumbs))
// }

export const setBreadCrumbs = (data: any[]) => {
  const { dispatch, getState } = store;
  const { breadcrumbs } = getState()?.common;

  // Find the current index
  const currentIndex = breadcrumbs.findIndex((b: any) =>
    Object.prototype.hasOwnProperty.call(b, 'current'),
  );

  const before = breadcrumbs.slice(0, currentIndex + 1);
  const after = breadcrumbs.slice(currentIndex + 1);

  // Insert new data after current
  const combined = [...before, ...data, ...after];

  // Use a Map to keep the last occurrence of each unique `path`
  const uniqueBreadcrumbs = Array.from(
    new Map(combined.map(b => [b.path, b])).values(),
  );

  dispatch(updateBreadcrumbs(uniqueBreadcrumbs));
};

/**
 * Updates the breadcrumbs in the store by adding a new breadcrumb to the existing list.
 * @param {any} data The new breadcrumb to add. Should contain a `label` and a `path`
 */
export const updateBreadcrumbsMethod = (data: any) => {
  const { dispatch } = store;

  return dispatch(updateBreadcrumbs(data));
};

export const removeBreadCrumbs = () => {
  const { dispatch } = store;
  dispatch(updateBreadcrumbs([]));
};

export const getAssosiatedListings = () => {
  const apiEndpoint = endPoints.assosiatedEntities;

  store.dispatch(setCommonDataLoader(true));
  getApiCall(
    `${apiEndpoint}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        store.dispatch(setAssosiatedList(data.data));
      }
      store.dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      console.log(e);
      store.dispatch(setCommonDataLoader(false));
      notify(`Error while fetching deparment list`, 'error');
    },
  );
};

export const leaveEntity = (
  values?: any,
  entityId?: any,
  cb?: any,
  _entityType?: string,
) => {
  putApiCall(
    `${endPoints.LeaveEntity}${entityId}`,
    values,
    (s: any) => {
      const {
        data: { statusCode },
      } = s;
      cb && cb();

      if (statusCode && statusCode === 200) {
        //  notify(message, 'success')
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
};

export const EditProfileData = (values?: any, cb?: any) => {
  // return (dispatch: any, getState: any) => {
  console.log('dataToSend', values);
  // dispatch(setCommonDataLoader(true))
  putApiCall(
    `${endPoints.editProfile}`,
    values,
    (s: any) => {
      const {
        data: { statusCode },
      } = s;
      cb && cb();

      console.log('RESSS', s);
      if (statusCode && statusCode === 200) {
        //  notify(message, 'success')
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
  // }
};

export const getUserPermission = (
  entityId: string,
  userId?: string,
  onSettled?: () => void,
) => {
  let apiEndpoint = `${endPoints.userPermission}${entityId}/permission`;

  if (userId) {
    apiEndpoint += `?userId=${userId}`;
  }

  store.dispatch(setCommonDataLoader(true));
  getApiCall(
    `${apiEndpoint}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        store.dispatch(setUserPermissionData(data.data));
      }
      store.dispatch(setCommonDataLoader(false));
      onSettled?.();
    },
    //Loading..
    (_e: any) => {
      store.dispatch(setCommonDataLoader(false));
      notify(`Error while fetching deparment list`, 'error');
      onSettled?.();
    },
  );
};

export const getAccessControlData = () => {
  const apiEndpoint = `${endPoints.accessControl}`;

  store.dispatch(setCommonDataLoader(true));
  getApiCall(
    `${apiEndpoint}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        store.dispatch(setAccountControlData(data.data));
      }
      // store.dispatch(setCommonDataLoader(false));
    },
    (_e: any) => {
      store.dispatch(setCommonDataLoader(false));
      notify(`Error while fetching deparment list`, 'error');
    },
  );
};

export const updateAccountControl = (
  values?: any,
  entityId?: any,
  cb?: any,
) => {
  putApiCall(
    `${endPoints.accessControl}`,
    values,
    (s: any) => {
      const {
        data: { statusCode, message },
      } = s;
      cb && cb();

      console.log('RESSS', s);
      if (statusCode && statusCode === 200) {
        if (values?.visibility) {
          notify(message, 'success');
        }
      }
    },
    (e: any) => {
      if (e?.data && e?.data.message) {
        notify(e?.data.message, 'error');
      }
    },
  );
  // }
};

export const setSpendingBreadCrumbs = (data: any[]) => {
  const { dispatch, getState } = store;
  const { spendingBreadcrumbs } = getState()?.common;
  console.log('wbdkwvkfvwfhvwfjkvwk', spendingBreadcrumbs);
  // Find the current index
  const currentIndex = spendingBreadcrumbs?.findIndex((b: any) =>
    Object.prototype.hasOwnProperty.call(b, 'current'),
  );

  // If no current index, treat all as before
  const before =
    currentIndex !== -1
      ? spendingBreadcrumbs.slice(0, currentIndex + 1)
      : [...spendingBreadcrumbs];
  const after =
    currentIndex !== -1 ? spendingBreadcrumbs.slice(currentIndex + 1) : [];

  // Insert new data after current
  const combined = [...before, ...data, ...after];

  // Ensure uniqueness by `path`, keeping the last occurrence
  const uniqueBreadcrumbs = Array.from(
    new Map(combined.map(b => [b.path, b])).values(),
  );

  dispatch(updateSpendingBreadcrumbs(uniqueBreadcrumbs));
};

export const removeSpendingBreadCrumbs = () => {
  const { dispatch } = store;
  dispatch(updateSpendingBreadcrumbs([]));
};

export const updateSpendingBreadcrumbsMethod = (data: any) => {
  const { dispatch } = store;

  return dispatch(updateSpendingBreadcrumbs(data));
};

export const getFilteredOrderListForDept = (
  productionId?: any,
  episodeId?: any,
  setId?: any,
  locationId?: string,
  departmentId?: any,
  modelEntityType?: string,
  modelEntityId?: string,
  entityId?: string,
  entityType?: string,
) => {
  let apiEndpoint = `${endPoints.spending.spendingOrder}`;

  if (productionId) {
    apiEndpoint += `?productionId=${productionId}`;
  }
  if (departmentId) {
    apiEndpoint += `&departmentId=${departmentId}`;
  }
  if (episodeId) {
    apiEndpoint += `&episodeId=${episodeId}`;
  }
  if (setId) {
    apiEndpoint += `&setId=${setId}`;
  }
  if (locationId) {
    apiEndpoint += `&locationId=${locationId}`;
  }
  if (modelEntityId) {
    apiEndpoint += `&modelEntityId=${modelEntityId}`;
  }
  if (modelEntityType) {
    apiEndpoint += `&modelEntityType=${modelEntityType}`;
  }
  if (entityId) {
    apiEndpoint += `&entityId=${entityId}`;
  }
  if (entityType) {
    apiEndpoint += `&entityType=${entityType}`;
  }
  store.dispatch(setCommonDataLoader(true));
  getApiCall(
    `${apiEndpoint}`,
    (s: any) => {
      const { data } = s;
      if (data.data) {
        store.dispatch(setOrderListDept(data.data));
      }
      store.dispatch(setCommonDataLoader(false));
    },
    (e: any) => {
      console.log(e);
      store.dispatch(setCommonDataLoader(false));
      notify(`Error while fetching department list`, 'error');
    },
  );
};

export const getPreviewShiftDetails = (data: any) => {
  const { dispatch } = store;
  dispatch(setPreviewShiftDetails(data));
};

export const removePreviewShiftDetails = () => {
  const { dispatch } = store;
  dispatch(setPreviewShiftDetails({}));
};

export const addNewJobTitle = (data: any) => {
  postApiCall(
    endPoints.common.addNewJobTitle,
    data,
    (_s: any) => {
      store.dispatch(setCommonDataLoader(false));
      getRoleList(data.departmentId);
    },
    (e: any) => {
      store.dispatch(setCommonDataLoader(false));
      if (e?.data?.message === 'ROLE_ALREADY_EXIST') {
        notify('This Job Title already exists', 'error');
      }
    },
  );
};

export const setRiskBreadCrumbs = (data: any[]) => {
  const { dispatch, getState } = store;
  const { riskBreadcrumbs } = getState()?.common;

  // Find the current index
  const currentIndex = riskBreadcrumbs?.findIndex((b: any) =>
    Object.prototype.hasOwnProperty.call(b, 'current'),
  );

  // If no current index, treat all as before
  const before =
    currentIndex !== -1
      ? riskBreadcrumbs?.slice(0, currentIndex + 1)
      : [...riskBreadcrumbs];
  const after =
    currentIndex !== -1 ? riskBreadcrumbs?.slice(currentIndex + 1) : [];

  // Insert new data after current
  const combined = [...before, ...data, ...after];

  // Ensure uniqueness by `path`, keeping the last occurrence
  const uniqueBreadcrumbs = Array.from(
    new Map(combined.map(b => [b.path, b])).values(),
  );

  dispatch(updateRiskBreadcrumbs(uniqueBreadcrumbs));
};

export const removeRiskBreadCrumbs = () => {
  const { dispatch } = store;
  dispatch(updateRiskBreadcrumbs([]));
};

export const updateRiskBreadcrumbsMethod = (data: any) => {
  const { dispatch } = store;

  return dispatch(updateRiskBreadcrumbs(data));
};

export const getRiskAnalystUser = (
  entityId: string,
  entityType: string,
): Promise<boolean> => {
  const { dispatch } = store;
  dispatch(setVerifyOtpLoading(true));
  const apiEndpoint = `${endPoints.riskUser}?entityId=${entityId}&entityType=${entityType}`;
  return new Promise((resolve, reject) => {
    getApiCall(
      apiEndpoint,
      (s: any) => {
        const hasRiskCentrePermission =
          !!s?.data?.data?.hasRiskCentrePermission;
        // keep your global flag if you still need it elsewhere
        dispatch(setVerifyOtpLoading(false));
        store.dispatch(setIsRiskAnalystUser(hasRiskCentrePermission));
        resolve(hasRiskCentrePermission);
      },
      (e: any) => {
        dispatch(setVerifyOtpLoading(false));
        notify('Error while fetching risk user info', 'error');
        reject(e);
      },
    );
  });
};
